import PropTypes from 'prop-types';
import styled from 'styled-components';


export const Flexbox = styled.div`
    display: flex;
    flex-direction: ${props => props.isVertical ? 'column' : 'row'};
    flex-wrap: nowrap;
    align-items: ${props => props.isCentered ? 'center' : 'unset'};
`;

Flexbox.propTypes = {
    isVertical: PropTypes.bool,
    isCentered: PropTypes.bool
};

export default Flexbox;

export const FlexboxColumn = styled.div`
  flex-grow: ${props => props.width ? 0 : 1};
  flex-shrink: ${props => props.width ? 0 : 1};  
  width: ${props => props.width ? `${props.width}px` : 'auto'};
`;

FlexboxColumn.propTypes = {
    width: PropTypes.number
};
